import React, { useState, useEffect } from "react";
import Navigationbar from './Navigationbar';
import '../Pages/Settings/SubNavbar.css';
import EmailAddresses from './Settings/EmailAddresses';
import WhatInfo from './Settings/WhatInfo';
import ScheduledTime from './Settings/ScheduledTime';
import CreateRecordPolicyTemplate from './SystemManager/HealthPolicyTemplate'
import { useLocation } from "react-router-dom";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import { getFreshToken } from '../custom_libraries/serverRequests';


const Settings = () => {
  const [activeMainTab, setActiveMainTab] = useState(0); // Main tab index
  const [activeSubTab, setActiveSubTab] = useState(0); // Subtab index

    useEffect(() => {
      validateSignedIn() 
    }, []);

  const validateSignedIn = async () => {
      let is_fresh_token = await getFreshToken()
      if (!is_fresh_token) {
          window.location.replace("/");
          return
      }
  }

  // Main tab content
  const mainTabs = [
    {
      label: "Notification Settings",
      // subtabs: ["Schedule Time", "Email Address", "What Info"],
      // content: [<ScheduledTime />, <EmailAddresses />, <WhatInfo />], //commented to remove Schedlued Time due to requirement
      subtabs: ["Email Address", "What Info"],
      content: [<EmailAddresses />, <WhatInfo />],

    },
    {
      label: "Recording Template Settings",
      // subtabs: ["Create Record Policy Template"],
      content: [<CreateRecordPolicyTemplate />],
    },
  ];

  return (
    <div style={{ height: "100vh", overflow: "hidden" }}>
      {/* Navigation Bar */}
      <Navigationbar /> &emsp;
      <div style={{marginLeft:'3%'}}>
        {/* Main Tabs */}
        <Box sx={{ borderBottom: 1, borderColor: "divider", ml: 10, backgroundColor:'#f3f3f3' }}>
        <Tabs
          value={activeMainTab}
          onChange={(e, newValue) => {setActiveMainTab(newValue);
            setActiveSubTab(0); // Reset subtab when switching main tabs
          }}
          
          textColor="primary"
          indicatorColor="primary"
          // centered
        >
          {mainTabs.map((tab, index) => (
            <Tab key={index} label={tab.label}
            sx={{
              "&.Mui-selected": {
                backgroundColor: "#d1e8ff",
                fontWeight: 550,
              },
            }}
             />
          ))}
        </Tabs>

        </Box>

        {/* Conditional Rendering for Subtabs */}
        {mainTabs[activeMainTab].subtabs ? (
          <Box sx={{ borderBottom: 1, borderColor: "divider", mt: 2, ml: 10 }}>
            <Tabs
              value={activeSubTab}
              onChange={(e, newValue) => setActiveSubTab(newValue)}
              textColor="black"
            >
              {mainTabs[activeMainTab].subtabs.map((subTab, index) => (
                <Tab key={index} label={subTab} />
              ))}
            </Tabs>
          </Box>
        ) : null}

        {/* Tab Content */}
        <Box sx={{ p: 3 }}>
          <Typography component="div">
            {mainTabs[activeMainTab].subtabs
              ? mainTabs[activeMainTab].content[activeSubTab]
              : mainTabs[activeMainTab].content}
          </Typography>
        </Box>
      </div>
    </div>
  );
};

export default Settings;
